export enum LoadingType {
  Default = 'skeleton',
  Overlay = 'spinner-overlay'
}
